import React from "react";
import { Link as BaseLink } from "@remix-run/react";
import className from "~/kernel/styling/className";

type Props = {
  to: string;
  children: React.ReactNode;
  target?: string;
  external?: boolean;
  color?: "white" | "blue";
  tabIndex?: number;
  rel?: string;
  onClick?: () => void;
};

export default function Link({
  to,
  children,
  target,
  external = false,
  color = "blue",
  tabIndex,
  onClick,
  rel,
}: Props) {
  const classes = className({
    "text-secondary": color === "blue",
    "text-white underline": color === "white",
  });

  if (external) {
    return (
      <a
        tabIndex={tabIndex}
        href={to}
        rel={rel}
        target={target}
        className={classes}
        onClick={onClick}
      >
        {children}
      </a>
    );
  }

  return (
    <BaseLink
      tabIndex={tabIndex}
      to={to}
      rel={rel}
      className={classes}
      target={target}
      onClick={onClick}
    >
      {children}
    </BaseLink>
  );
}

Link.defaultProps = {
  external: false,
};
